import React from "react";
import useBreakpoint from "../../../../utils/useBreakpoint";
import { LandTourCompulsoryCharge } from "../../../../interfaces/land-tour.interface";
import GroundTourModal from "./GroundTourModal";

interface Props {
  open: boolean;
  onClose: () => void;
  charges: LandTourCompulsoryCharge[];
}

// Per-tour mandatory charges (issue #629 (c)3/4) - distinct from the sidebar's own price
// breakdown, since these apply regardless of which pax types the traveller picks. "Pax"
// charges are per traveller, "Group" charges are once per booking.
export default function CompulsoryChargesModal({ open, onClose, charges }: Props) {
  const isMobile = useBreakpoint();
  if (!open) return null;

  const paxCharges = charges.filter((charge) => charge.type === "Pax");
  const groupCharges = charges.filter((charge) => charge.type === "Group");

  return (
    <GroundTourModal open={open} onClose={onClose} title="Compulsory Charges" isMobile={isMobile}>
      <div className="ground-tour-show-v2__compulsory-charges">
        {paxCharges.length > 0 && (
          <div className="ground-tour-show-v2__compulsory-group">
            <h4>Per Traveller</h4>
            <ul>
              {paxCharges.map((charge, index) => (
                <li key={index}>
                  <span>{charge.title}</span>
                  <span>RM {Number(charge.price).toFixed(2)}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {groupCharges.length > 0 && (
          <div className="ground-tour-show-v2__compulsory-group">
            <h4>Per Booking</h4>
            <ul>
              {groupCharges.map((charge, index) => (
                <li key={index}>
                  <span>{charge.title}</span>
                  <span>RM {Number(charge.price).toFixed(2)}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </GroundTourModal>
  );
}
